const routes = [
    {
        path: "/unit",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "unit_index",
        }
    }
];

export default routes;
